"use strict";

var _interopRequireDefault = require("E:/zkdn_workspace/zhijiao/bjzyjy-mhwz/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
require("core-js/modules/es7.object.get-own-property-descriptors");
require("core-js/modules/web.dom.iterable");
require("core-js/modules/es6.object.keys");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/es6.function.name");
var _defineProperty2 = _interopRequireDefault(require("E:/zkdn_workspace/zhijiao/bjzyjy-mhwz/node_modules/@babel/runtime/helpers/defineProperty.js"));
var _tablePage = _interopRequireDefault(require("@/components/CommonForm/table-page"));
var _leave = require("_a/office/leave/leave");
var _vuex = require("vuex");
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2.default)(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; } //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  name: 'leave-apply',
  components: {
    TablePage: _tablePage.default
  },
  data: function data() {
    return {
      form: {},
      rules: {
        leaveDate: [{
          type: 'array',
          required: true,
          message: '请选择开始时间和结束时间',
          trigger: 'change',
          fields: {
            0: {
              type: 'string',
              required: true,
              message: '请选择开始日期'
            },
            1: {
              type: 'string',
              required: true,
              message: '请选择结束日期'
            }
          }
        }],
        type: [this.$ruler('请假类型')],
        reason: [this.$ruler('请假事由')]
      },
      leaveTypeOptionList: []
    };
  },
  watch: {
    'form.leaveDate': function formLeaveDate(newVal, oldVal) {
      if (newVal !== undefined && newVal !== null) {
        this.form.beginDate = newVal[0];
        this.form.endDate = newVal[1];
      }
    }
  },
  methods: _objectSpread(_objectSpread({}, (0, _vuex.mapActions)(['getDictListByType'])), {}, {
    change: function change(e) {
      this.$forceUpdate();
    },
    /**
     * 重置表单
     * @param name
     */
    handleReset: function handleReset(name) {
      this.dialogShow = false;
      this.$refs[name].resetFields();
    },
    handleSave: function handleSave(name) {
      var _this = this;
      this.$refs[name].validate(function (valid) {
        if (valid) {
          delete _this.form.leaveDate;
          (0, _leave.saveLeave)(_this.form).then(function (res) {
            if (res.data) {
              _this.$message.success("保存成功");
            } else {
              _this.$message.error("保存失败");
            }
            // 清空表单
            _this.handleReset('form');
          });
        }
      });
    },
    /**
     * 提交表单
     * @param name
     */
    handleSubmit: function handleSubmit(name) {
      var _this2 = this;
      this.$refs[name].validate(function (valid) {
        if (valid) {
          delete _this2.form.leaveDate;
          (0, _leave.createAndSubmitLeave)(_this2.form).then(function (res) {
            if (res.data) {
              _this2.$message.success("提交成功");
            } else {
              _this2.$message.error("提交失败");
            }
            // 清空表单
            _this2.handleReset('form');
          });
        }
      });
    }
  }),
  mounted: function mounted() {
    var _this3 = this;
    this.getDictListByType('leave_type').then(function (res) {
      _this3.leaveTypeOptionList = res;
    });
  }
};